import styled from "styled-components";
import { linkAccent, backgroundColor, linkHoveredAccent, breakpoint4k, breakpointMedium, breakpointLarge } from '../../variables'

export const Button = styled.button`
    padding: 19px 28px;
    font-size: 13px;
    border: 0;
    letter-spacing: 0.12em;
    font-weight: 700;
    text-transform: uppercase;
    background: ${linkAccent};
    color: ${backgroundColor};
    cursor: pointer;


    &:hover{
        background: ${linkHoveredAccent};
    }

    @media(min-width: ${breakpointMedium}){
        padding: 19px 30px;
        font-size: 16px;
    }

    @media(min-width: ${breakpointLarge}){
        padding: 25px 56px;
        font-size: 18px;
    }

    @media(min-width: ${breakpoint4k}){
        padding: 20px 25px;
    }
`;